const API_CONFIG = {
    menu: "https://api.myjson.com/bins/1d3s0o",

    /* 上下文 */
    PROJECTMAPPING: {
        SELFCARE: "cic-selfcare",
        SSO: "esc-sso",
        ESC: "esc-self",
        PORTAL: "portal",
        IDM: "esc-idm"
    },

    logoutSysetem: "/ngw/logout",

    /* 帮助文档地址 */
    HELPURL: "https://cic.sso360.cn/deploy/#/platform",

    /* 待办 */
    TODO: "/rest/selfcare/dingTalk/workplan",

    //创建代办

    ADDTODO: "/rest/selfcare/workplan",

    /*完成钉钉代办*/
    FINISHTODO: "/rest/selfcare/dingTalk/workplan/finish",

    /* 个人信息 */
    USERINFO: "/rest/selfcare/findUser",// /rest/selfClient/users/get/user
    // 租户下某种type(如USER)所有属性字段查询
    schemas: "rest/selfClient/schemas",

    /* 首页模板配置 */
    GETCONFIG: "/rest/selfClient/users/getConfig",
    SETCONFIG: "/rest/selfClient/users/updateConfig",

    // console api
    consoleCTX: "esc-idm",

    /* Header */
    ESSOAUTH: "/cxf/api/v1/systemConfig/query/esso_auth", // 查询是否启用esso
    QUERYATAUTH: "/cxf/api/v1/systemConfig/query/at_auth", // 获取跨浏览器是否开启
    QUERYOTPAUTH: "/cxf/api/v1/systemConfig/query/otp_auth", // 获取跨otp是否开启
    SETTICKET: "/setticket", // 提交ticket
    PASSWORDEXPIRED: "/rest/selfcare/passwordPolicy/remind/passwordExpired", //密码失效时间

    /* 应用 */
    APPLICATIONOWN: "/rest/selfcare/app/sort", // 移动端过滤掉esso和nsso为false的app
    APPRESOURCE: "/rest/selfClient/app/query/app/own", // 获取APP
    CREATEACCOUNTS: "rest/selfClient/app/create/account", // 获取自助帐号
    APPTOKENGETCODE: "api/v1/loginLog/getCode", // app 跳转带获取token
    UPDATEACCOUNT: "rest/selfClient/app/batch/accounts", // 更新app帐号
    CREATEABETCHCCOUNTS: "rest/selfClient/app/batch/accounts", // 批量创建帐号
    DELETEACCOUNTS: "rest/selfClient/app/account", // 删除应用下的帐号
    /* 新版本Application */
    apps: "/rest/selfcare/apps",
    sort: "/rest/selfcare/app/sort",
    token: "/rest/selfcare/token", // token
    run: "/run?appkey=",
    profile: "/rest/selfcare/esso/profile",
    account: "/rest/selfcare/esso/account",

    // 绑定互联网认证
    bindInternet: "/internet/connect",
    changePassword: "/rest/selfcare/changePassword", // 更新密码

    passwordPolicyDefault: "/rest/selfcare/passwordPolicy/default", // 获取密码策略
    passwordPolicyLogin: "/rest/selfcare/passwordPolicy/login", // 获取密码策略
    sendCode: "/rest/selfClient/password/sendCode", // 获取验证码

    unauthorizedSendCode: "/rest/selfClient/password/unauthorized/sendCode", // 未认证的
    // 短信邮件校验验证码
    checkProvider: "rest/selfClient/password/checkProvider",
    unauthorizedCheckProvider: "rest/selfClient/password/unauthorized/checkProvider",

    getUnAuthAllV1: "rest/cfgsms/getunauthall/v1", // 短信验证 未认证
    getAllV1: "rest/cfgsms/getall/v1", // 短信验证 认证

    // 获取ESSO绑定的系统名称和密码,绑定系统用户
    systemUser: "/systemuser",

    // 测试ESSO接口
    testConn: "/testconn",

    // 绑定系统用户
    bindSystemUserInfo: "/api/v1/desktop/bindSystemUserInfo",
    // 解绑系统用户
    unbindSystemUserInfo: "/api/v1/desktop/unbindSystemUserInfo",

    // 获取是否互联网认证
    internetIsBind: "/internet/connect/isbind",
    internetIsBindAll: "/internet/connect/isbindAll",
    // 解绑互联网认证
    internetUnbind: "/internet/connect/unbind",
    getFingerDataListByUserName: "/api/v1/biology/getFingerDataListByUserName", // 获取指纹是否绑定
    setFingerData: "/api/v1/biology/setFingerData", // 绑定指纹
    clearFingerDataList: "/api/v1/biology/clearFingerDataList", // 指纹解绑
    getBiologFixByUserName: "/api/v1/biology/getBiologFixByUserName", // 获取人脸,指纹是否打开,人脸,是否注册信息
    users: "rest/selfClient/users", // 修改用户信息
    link: "/rest/link/query/v1?page=&size=100", // 常用链接接口
    announcementList: "/rest/announcement/queryV2?size=25&page=", // 新闻公告列表
    announcementDetails: "/rest/announcement/selectById/", // 新闻公告详情
    pluginList: "/rest/general/search", // 插件列表
    msgList: "/rest/selfClient/msg/getnotice?size=15&page=", // 消息列表
    updateMsgSettings: "/rest/selfClient/msg/updateMsgSettings", // 消息已读
    addressQueryUsers: "/rest/selfClient/addressBook/queryUsers", //获取通讯录用户信息
    allAssociateTO: "/rest/selfClient/addressBook/allAssociateTO", //根据组织ID查询所有下级组织和组及用户
    appManage: "/rest/selfClient/app/query/app/own", //应用管理
    userConfig: "/rest/selfClient/users/getConfig", //用户布局配置信息
    createAccount: "/rest/selfClient/app/create/account", // 创建帐号
    appTokengetCode: "/api/v1/loginLog/getCode", // app 跳转带获取token

    /* 在线设备 */
    // onlineDevice: "/rest/sso/queryOnlineDevice", // 获取在线设备列表
    // offLineOthersDevice: "/rest/sso/deleteByTgt", // 离线所有设备
    // offLineAllDevice: "/rest/sso/deleteByUsername", // 离线所有设备
    /* 2020年08月24日11:46:09 */
    onLineDevice: "/cxf/api/v1/ssoSession/queryByUsername",
    offLineAllDevice: "/cxf/api/v1/ssoSession/deleteByUsername",
    offLineOthersDevice: "/cxf/api/v1/ssoSession/deleteByTGT",
    sessionManager: "/cxf/api/v1/ssoSession/queryChildrenTokensByUsername",
    sessionManagerById: "/cxf/api/v1/ssoSession/deleteChildrenTokensByTokenId",
    /* 登录历史 */
    // https://paraview.sso360.in/api/tsdb/query
    // loginHistoryList: "/rest/sso/loginHistory", // 登录历史列表
    loginHistoryList: "/rest/selfcare/sysloginlog", // 登录历史列表

    /*首页 EIC接口*/
    general: "/rest/general", // 布局配置信息

    /*安全设置 EIC接口*/
    getToken: "/rest/selfcare/token",
    getBindInfo: "/rest/selfcare/security/methods",
    getInternetBindInfo: "/cxf/api/v1/systemConfig/query",
    isBind: "/internet/connect/isbind",
    getSystemValid: "/cxf/api/v1/auth/queryAllValid", // 获取系统是否开启
    getSystemBind: "/api/v1/desktop/isbindSystemUserInfo", // 获取是否绑定系统
    getBiolog: "/api/v1/biology/getBiologFixByUserName", // 获取人脸,指纹是否打开,人脸,是否注册信息
    getFinger: "/rest/selfcare/finger", // 获取指纹是否绑定
    // 忘记密码
    resetType: "/rest/selfcare/home/password/resetType?username=", // 获取密码找回方式
    resetTypeByCode: "/rest/selfcare/home/password/resetTypeByCode", // 获取密码找回方式
    sendMsg: "/rest/selfcare/home/password/sendMsg",  // 发送验证码
    resetPassword: "/rest/selfcare/home/password/reset",  // 忘记密码的修改密码
    securityQus: "/rest/selfcare/security/questions",  // 获取密保问题
    bindSystemUserinfo: "/api/v1/desktop/bindSystemUserInfo", // 绑定系统用户
    getQuestions: "/rest/selfcare/security/questions", // 获取问题列表
    appBingUser: "/rest/selfcare/mobileDevice",
    sendValidCode: "/rest/selfcare/security/bindSendMsg", // 发送验证码 绑定
    sendValidCodeUnbind: "/rest/selfcare/security/unbindSendMsg", // 发送验证码 解绑
    messageUnbind: "/rest/selfcare/security/unbind", // 确认解绑
    messageBind: "/rest/selfcare/security/bind", // 确认绑定
    finger: "/rest/selfcare/finger", // 查询或删除指纹
    modifyPassword: "/rest/selfcare/modifyPassword", // 强制修改密码
    accountDeputy: "/app/accountDeputy/list", // 当前委托
    accountDeputyDelay: "/rest/selfcare/deputy/app/accountDeputy/delay", // 延期
    accountDeputyRevoke: "/rest/selfcare/deputy/app/accountDeputy/revoke", // 延期

    /*帐号委托*/
    userList: "/self/user", // portal 用户接口
    // IDMuserList: "/idt/user/list", // IDM 用户接口
    IDMuserList: "/rest/selfcare/deputy/newDeputyAssignee", // IDM 用户接口
    IDMcommonDeputy: "/rest/selfcare/deputy/commonDeputy", // 获取常用委托人
    IDMcommonDeputyAdd: "/rest/selfcare/deputy/app/accountDeputy/add", // 新增帐号委托

    historyConsign: "/rest/selfcare/deputy/history", // 历史委托
    currentConsign: "/rest/selfcare/deputy/app/accountDeputy/list", // 当前委托
    currentConsignDetails: "/rest/selfcare/deputy/idt/deputy/get", // 当前委托详情
    configurationList: "/rest/selfcare/deputy/sys/configuration/list", // 平台参数查询

    /* 菜单 */
    menuList: `/rest/selfcare/acl/menu/list`,
    menuFunction: `/rest/selfcare/acl/function/list`, // 获取方法信息,

    /* 动态表单 */
    flexiBleForm: "/rest/selfcare/flexibleForm/get", // /self/flexibleForm/get获取动态表单id
    snackbarScript: "/rest/design/page", // snackbar 动态表单的脚本

    // 获取证书的密码
    CERSERIALNUMBER: "/cer/certificate-user-link/userCerPwd/uid/",
    // 个人证书下载
    PERSONALCER: "/cer/certificate-user-link/uidCer/download/",

    pushToMobile: "/api/v1/appCheck/pushToMobile",
    checkingLogin: "/api/v3/longPolling/checkingLogin",
    // 新版 esso 里面查询esso是否开启和otp是否开启
    queryAllValid: "/api/v3/auth/queryAllValid",
    headerInfo: "/rest/selfcare/indexHeader/get",
    originUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''), // 兼容IE的origin值
    // originUrl: "http://eicdev53.sso360.cn:10053", // 兼容IE的origin值

    // superID
    findSuperId: "/rest/selfcare/superId/list", // superID绑定列表
    sendCodeByMobile: "/rest/selfcare/superId/sendMsg", // superID绑定发送验证码
    superIdUnbind: "/rest/selfcare/superId/unbind", // superId解绑
};
const PORTAL_LOCALSTORAGE_KEY = "portal";
const PORTAL_CTX = "portal";
const PORTAL_CFG_CTX = "cic-cfg";
const PORTAL_SSO_CTX = "cic-sso";
const PORTAL_SSO = "esc-sso";
const PORTAL_SELF = "esc-self";
export {
    API_CONFIG,
    PORTAL_LOCALSTORAGE_KEY,
    PORTAL_CTX,
    PORTAL_CFG_CTX,
    PORTAL_SSO_CTX,
    PORTAL_SSO,
    PORTAL_SELF
};
export default API_CONFIG;
